import { ComponentChildren, h } from "preact";
import "./container.scss";

interface Props {
    class?: string;
    children?: ComponentChildren;
}

export function Container(props: Props) {
    return (
        <div class={"material-container" + (props.class ? (" " + props.class) : "")}>
            {
                props.children
            }
        </div>
    );
}
